<template>
    <div class="mobile-main-header">
        <div class="mb-1 navbar navbar-expand-lg  nav nav-item  navbar-nav-right responsive-navbar navbar-dark  ">
          <div class="collapse navbar-collapse" id="navbarSupportedContent-4">
            <div class="d-flex order-lg-2 mr-auto">
              <div class="dropdown main-header-notification">
                <a class="nav-link icon" href="#">
                  <i class="fe fe-bell header-icons"></i>
                  <span class="badge badge-danger nav-link-badge">1</span>
                </a>
                <div class="dropdown-menu">
                  <div class="header-navheading">
                    <p class="main-notification-text">شما 1 اعلان خوانده نشده <span class="badge badge-pill badge-primary mr-3">مشاهده همه</span></p>
                  </div>
                  <div class="main-notification-list">
                    <div class="media new">
                      <div class="main-img-user online"><img alt="آواتار" src="/assets/img/users/5.jpg"></div>
                      <div class="media-body">
                        <p>تست عنوان نوتیفیکیشن جدید</p>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown-footer">
                    <a href="#">مشاهده همه اعلان ها</a>
                  </div>
                </div>
              </div>
              <div class="dropdown main-profile-menu">
                <a class="d-flex" href="#">
                  <span class="main-img-user"><img alt="آواتار" src="/assets/img/users/default.jpg"></span>
                </a>
                <div class="dropdown-menu">
                  <div class="header-navheading">
                    <h6 class="main-notification-title">تست</h6>
                  </div>
                  <a class="dropdown-item" v-on:click="logout">
                    <i class="fe fe-power"></i> خروج از سیستم
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header-Mobile',
    methods: {
      logout(e){
        e.preventDefault();
        localStorage.removeItem('agc-token');
        this.$router.push({name: 'login'});
      }
    }
}
</script>